/**
 * Duration formatting shared by the usage grids and the memos surfaces
 * (grid column, audio player). Moved verbatim from
 * `apps/web/src/components/usage/usageGridColumns.tsx`.
 */
/** Seconds → `h:mm:ss` (or `m:ss` under an hour). */
export function formatDurationSeconds(seconds) {
    const total = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const mm = m.toString().padStart(2, "0");
    const ss = s.toString().padStart(2, "0");
    return h > 0 ? `${h}:${mm}:${ss}` : `${m}:${ss}`;
}
//# sourceMappingURL=duration.js.map